import { mapActions, mapState } from 'vuex'
import EditarAcarreoView from '@/components/Layout/Menu/Gestores/Acarreo/Editar_acarreo/EditarAcarreoView.vue'
import FiltroReportes from '@/components/Layout/Menu/Filtros/Filtro_Reportes/FiltroReportes.vue'
import * as XLSX from 'xlsx/xlsx.mjs'
import gsap from 'gsap'

export default {
  name: 'GestorAcarreoView',
  components: {
    EditarAcarreoView,
    FiltroReportes
  },
  data: function () {
    return {
      optionEstadosAcarreo: [
        { value: null, text: '- Estados' }
      ],
      items: [],
      fields: [
        { key: 'id', label: 'id', sortable: true, sortDirection: 'desc' },
        // { key: 'nro_transporte', label: 'Nro Transporte', sortable: true, sortDirection: 'desc' },
        { key: 'conductor', label: 'Conductor', sortable: true, sortDirection: 'desc' },
        { key: 'patente', label: 'Patente', sortable: true, sortDirection: 'desc' },
        { key: 'folio', label: 'Folio', sortable: true, sortDirection: 'desc' },
        // { key: 'cam_basis', label: 'Cam Basis', sortable: true, sortDirection: 'desc' },
        // { key: 'administrador', label: 'Administrador', sortable: true, sortDirection: 'desc' },
        { key: 'fecha', label: 'Fecha', sortable: true, sortDirection: 'desc' },
        { key: 'estado', label: 'Estado', sortable: true, sortDirection: 'desc' },
        { key: 'editar', label: 'Editar', sortable: true, sortDirection: 'desc' }
      ],
      totalRows: 1,
      currentPage: 1,
      page: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: 'Muchos Registros' }],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      activeColor: 'arial',
      fontSize: 13,
      backgroundColor: '#91c27d',
      editarModal: {
        id: 'modal-editar-acarreo-filds',
        title: 'Editar Viaje',
        content: ''
      },
      estadosAcarreoRegistros: {},
      dataFiltroReporte: null,
      filterAcarreo: {},
      loadingTable: false,
      loadingExcel: false
    }
  },
  props: {
  },
  watch: {
    dataFiltroReporte: function (val) {
      console.log(this.dataFiltroReporte)
      console.log(this.PeriodoFechaActual())
      const data = this.nextPage()
      this.findAcarreo(data)
    },
    perPage: function (val) {
      console.log(this.PeriodoFechaActual())
      this.page = 1
      const data = this.nextPage()
      this.findAcarreo(data)
    }
  },
  mounted () {
    this.filterAcarreo = this.PeriodoFechaActual()
    const data = this.nextPage()
    this.findAcarreo(data)
    this.getEstadosAcarreo().then((res) => {
      console.log(this.estadosAcarreo)
      for (const e in this.estadosAcarreo) {
        this.optionEstadosAcarreo.push({ value: this.estadosAcarreo[e], text: this.estadosAcarreo[e] })
      }
      console.log(this.optionEstadosAcarreo)
    })
    this._initAnimations()
  },
  beforeDestroy () {
    if (this._mm) this._mm.revert()
  },
  methods: {
    ...mapActions('Acarreo', [
      'getAcarreo', 'updateEstadoAcarreo', 'updateAcarreo', 'deleteAcarreo', 'getEstadosAcarreo', 'getAcarreoFilter', 'getAcarreoReports'
    ]),
    ...mapActions('Reportes', [
      'getReporteAcarreo'
    ]),
    getFieldValue (fields, fieldName) {
      const field = fields.find(f => f.field_name === fieldName)
      return field ? field.field_value : ''
    },
    findAcarreo (data) {
      if (this.dataFiltroReporte !== null) {
        data.fechaDesde = this.dataFiltroReporte.fechaDesde
        data.fechaHasta = this.dataFiltroReporte.fechaHasta
        data.estado = this.dataFiltroReporte.estadoAcarreo
        data.administrador = this.dataFiltroReporte.administrador
        data.patente = this.dataFiltroReporte.patente
        data.conductor = this.dataFiltroReporte.conductor
        data.centroCosto = this.dataFiltroReporte.centroCosto
        data.folio = this.dataFiltroReporte.folio || null
        data.fieldName = this.dataFiltroReporte.fieldName || null
        data.fieldValue = this.dataFiltroReporte.fieldValue || null
      } else {
        const date = this.PeriodoFechaActual()
        data.fechaDesde = date.fechaDesde
        data.fechaHasta = date.fechaHasta
      }
      this.loadingTable = true
      this.getAcarreoFilter(data).then((res) => {
        console.log(this.acarreo)
        this.items = []
        // Si la consulta fallo, antes se dejaban los datos de la busqueda
        // anterior en pantalla como si fueran el resultado nuevo.
        if (!res) {
          this.makeToast({ title: 'Error', variant: 'danger', body: 'No se pudo cargar el listado de viajes. Reintente.' })
          return
        }
        this.items = (this.acarreo && this.acarreo.content) ? this.acarreo.content : []
        this.creaListaEstadosAcarreo()
        this._animateTableRows()
      }).finally(() => {
        this.loadingTable = false
      })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getColorClass (estado) {
      switch (estado) {
        case 'APROBADO':
          return 'select-aprobado'
        case 'ELIMINADO':
          return 'select-eliminado'
        case 'POR_REVISAR':
          return 'select-por-revisar'
        default:
          return ''
      }
    },
    handlePageChange (value) {
      this.page = value
      const data = this.nextPage()
      this.findAcarreo(data)
    },
    nextPage () {
      const data = {
        page: (this.page - 1),
        size: this.perPage
      }
      return data
    },
    makeToast (toast) {
      this.$bvToast.toast(toast.body, {
        title: toast.title,
        variant: toast.variant,
        solid: true
      })
    },
    modalEditarsEnable (item, index, button) {
      // this.visitasModal.title = `Row index: ${index}`
      this.editarModal.content = JSON.stringify(item, null, 2)
      console.log(this.editarModal.content)
      this.$root.$emit('bv::show::modal', this.editarModal.id, button)
    },
    hideModalEditar () {
      this.$refs[this.editarModal.id].hide()
    },
    creaListaEstadosAcarreo () {
      console.log('creaListaEstadosAcarreo')
      console.log(this.items)
      this.estadosAcarreoRegistros = {}
      for (const estado in this.items) {
        this.estadosAcarreoRegistros[this.items[estado].id] = this.items[estado].estado
      }
      console.log(this.estadosAcarreoRegistros)
    },
    actualizaEstadoAcarreo (item) {
      console.log('actualizaEstadoAcarreo')
      console.log(item)
      console.log(this.estadosAcarreoRegistros[item.id])
      const data = {
        id_acarreo: item.id,
        estado: this.estadosAcarreoRegistros[item.id]
      }
      this.updateEstadoAcarreo(data).then((res) => {
        // Antes se ignoraba el resultado: si fallaba, el desplegable quedaba
        // mostrando el estado nuevo y la base conservaba el viejo, sin aviso.
        if (!res || res.status !== 200) {
          this.estadosAcarreoRegistros[item.id] = item.estado
          this.makeToast({ title: 'Error', variant: 'danger', body: 'No se pudo cambiar el estado del viaje.' })
        }
      })
    },
    emitEditarAcarreo () {
      const data = this.nextPage()
      this.findAcarreo(data)
      this.getEstadosAcarreo().then((res) => {
        console.log(this.filterAcarreo)
        for (const e in this.filterAcarreo) {
          if (e !== undefined && this.estados !== undefined) this.optionEstadosAcarreo.push({ value: this.estados[e], text: this.estados[e] })
        }
        console.log(this.optionEstadosAcarreo)
      })
      // this.hideModalEditar()
    },
    PeriodoFechaActual () {
      const date = new Date()
      const fechaActualPrimeraHora = `${
        date.getFullYear().toString().padStart(4, '0')}-${
          (date.getMonth() + 1).toString().padStart(2, '0')}-${
            date.getDate().toString().padStart(2, '0')} ${
              '00'}:${
                '00'}:${
                  '00'}`
      const fechaActualUltimaHora = `${
        date.getFullYear().toString().padStart(4, '0')}-${
          (date.getMonth() + 1).toString().padStart(2, '0')}-${
            date.getDate().toString().padStart(2, '0')} ${
              '23'}:${
                '59'}:${
                  '59'}`
      console.log(fechaActualPrimeraHora)
      console.log(fechaActualUltimaHora)
      const periodo = {}
      periodo.fechaDesde = fechaActualPrimeraHora
      periodo.fechaHasta = fechaActualUltimaHora
      return periodo
    },
    _initAnimations () {
      this._mm = gsap.matchMedia()
      this._mm.add(
        { animate: '(prefers-reduced-motion: no-preference)' },
        (ctx) => {
          const animate = ctx.conditions.animate
          const dur = animate ? 0.55 : 0
          const d1 = animate ? 0.12 : 0
          const d2 = animate ? 0.22 : 0
          const d3 = animate ? 0.30 : 0
          const d4 = animate ? 0.40 : 0

          gsap.fromTo(this.$refs.title,
            { autoAlpha: 0, y: -18 },
            { autoAlpha: 1, y: 0, duration: dur, ease: 'power2.out', clearProps: 'transform' }
          )
          gsap.fromTo(this.$refs.filterRow,
            { autoAlpha: 0, y: -12 },
            { autoAlpha: 1, y: 0, duration: dur, delay: d1, ease: 'power2.out', clearProps: 'transform' }
          )
          gsap.to(this.$refs.actionBar,
            { autoAlpha: 1, duration: dur, delay: d2, ease: 'power2.out' }
          )
          gsap.fromTo(this.$refs.tableCard,
            { autoAlpha: 0, y: 14 },
            { autoAlpha: 1, y: 0, duration: dur, delay: d3, ease: 'power2.out', clearProps: 'transform' }
          )
          gsap.to(this.$refs.paginationBar,
            { autoAlpha: 1, duration: dur, delay: d4, ease: 'power2.out' }
          )
        }
      )
    },

    _animateTableRows () {
      this.$nextTick(() => {
        const rows = document.querySelectorAll('.vps-table tbody tr')
        if (!rows.length) return
        gsap.fromTo(rows,
          { autoAlpha: 0, y: 8 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.28,
            stagger: 0.045,
            ease: 'power1.out',
            clearProps: 'transform,opacity,visibility'
          }
        )
      })
    },

    exportarExcel () {
      const data = {}
      if (this.dataFiltroReporte !== null) {
        data.fechaDesde = this.dataFiltroReporte.fechaDesde
        data.fechaHasta = this.dataFiltroReporte.fechaHasta
        data.estado = this.dataFiltroReporte.estadoAcarreo
        data.administrador = this.dataFiltroReporte.administrador
        data.centroCosto = this.dataFiltroReporte.centroCosto
      } else {
        const date = this.PeriodoFechaActual()
        data.fechaDesde = date.fechaDesde
        data.fechaHasta = date.fechaHasta
      }
      this.loadingExcel = true
      this.getReporteAcarreo(data).then(() => {
        const ws = XLSX.utils.json_to_sheet(
          this.reporteAcarreo.map(item =>
            Object.fromEntries(Object.entries(item).filter(([k]) => !k.includes('_cellVariants')))
          )
        )
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'acarreo')
        XLSX.writeFile(wb, 'acarreo.xlsx')
      }).finally(() => {
        this.loadingExcel = false
      })
    }
  },
  computed: {
    ...mapState('Acarreo', ['estadosAcarreo']),
    ...mapState('Acarreo', ['acarreoReports']),
    ...mapState('Acarreo', ['acarreo']),
    ...mapState('Reportes', ['reporteAcarreo']),
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  }
}
